import { useIntl } from "react-intl";

type Props = {
  exportType: string;
  dataExports: {
    id: number;
    type: string;
    status: string;
    createdAt: string;
    finishedAt?: string;
    availableUntil?: string;
    asset?: {
      serial_number?: string;
    };
    instrumentation?: {
      tag?: string;
    };
    batch?: {
      name?: string;
    };
  }[];
};

export function DataExportsDescription({ dataExports, exportType }: Props) {
  const intl = useIntl();
  const descriptions = [];
  if (exportType === "complete") {
    const exportCompleteDescription = dataExports.some(
      (exp) => exp.type === "complete",
    )
      ? intl.formatMessage({
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          id: `export_data.complete.explanation.${dataExports.find((a) => a.type === "complete").status}`,
        })
      : intl.formatMessage({ id: "export_data.complete.explanation" });
    descriptions.push(exportCompleteDescription);
  }

  if (
    dataExports.some((exp) => exp.type === "batch_values") ||
    dataExports?.some((exp) => exp.type === "instrumentation_values")
  ) {
    descriptions.push(
      intl.formatMessage({
        id: "export_data.instrumentation_batch_values.common",
      }),
    );
  }

  return (
    <div id="descriptions" className="space-before space-after">
      {descriptions.map((msg) => (
        <p key={`desc-msg-${msg}`}>{msg}</p>
      ))}
    </div>
  );
}
